import { useTranslation } from "react-i18next";
import { StSvg } from "../../common/svg/AllSvg";
import { useNavigate, useParams } from "react-router-dom";
import Error from "../../common/form/Error";
import EmptyList from "../../common/form/EmptyList";
import NoSearch from "../../common/form/NoSearch";
import { useSelector } from "react-redux";

const AllStores = ({ data, loading, search, setSearch, isError, category, categoryLoading, isCategoryError }: any) => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const { t } = useTranslation('common');
    const loaderData: any[] = [1, 2, 3, 4, 5, 6, 7, 8]
    const storeLoaderData: any[] = [1, 2, 3, 4]
    const navigate = useNavigate();
    const params = useParams();

    return (
        <div className="h-full pb-[30px] xlx:pb-[60px] pt-[30px] msm:pt-[50px] xlx:pt-[65px] flex flex-col gap-[40px] msm:gap-[60px] xlx:gap-[100px]">
            {/* categories */}
            <div className="flex flex-col gap-[20px]">
                <h3 className="text-primaryText dark:text-white font-semibold">{t("passenger.stores.category.title")}</h3>

                {categoryLoading ?
                    <div className='grid grid-cols-2 xsm:grid-cols-3 mdLgrid-cols-4 mms:grid-cols-5 msm:grid-cols-6 xl:grid-cols-8 gap-y-[20px] gap-x-[20px] 1.5xl:gap-x-[45px] w-full items-start'>
                        {Array.isArray(loaderData) && loaderData?.map((item: any, index: number) => (
                            <div className="!flex flex-col items-center justify-center gap-[15px] w-full animate-pulse" key={index}>
                                <div className="w-full h-[130px] flex items-center justify-center rounded-[20px] bg-gray-200 dark:bg-gray-700">
                                </div>
                                <div className="w-[80px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                            </div>
                        ))}
                    </div>
                    :
                    <>
                        {isCategoryError ?
                            <div className="h-full w-full my-[-30px] xlx:my-[-60px]">
                                <Error />
                            </div>
                            :
                            <>
                                {category?.length > 0 && <div className='grid grid-cols-2 xsm:grid-cols-3 mdLgrid-cols-4 mms:grid-cols-5 msm:grid-cols-6 xl:grid-cols-8 gap-y-[20px] gap-x-[20px] 1.5xl:gap-x-[45px] w-full items-start'>
                                    {Array.isArray(category) && category?.map((item: any, index: number) => (
                                        <div className="flex flex-col items-center justify-center gap-[15px] w-full" key={index}>
                                            <button className={`w-full h-[130px] flex items-center justify-center rounded-[20px] bg-[#F6F6F6] dark:bg-bgDark ${item?.total_store > 0 && 'focus:shadow-xl hover:shadow-xl dark:focus:shadow-[0px_8px_22px_-6px_#ffffff40,0px_14px_64px_-4px_#ffffff0d] dark:hover:shadow-[0px_8px_22px_-6px_#ffffff40,0px_14px_64px_-4px_#ffffff0d]'}`} disabled={item?.total_store === 0} onClick={() => !!params?.lang ? navigate(`/${params?.lang}/stores/${item?.id}`) : navigate(`/stores/${item?.id}`)}>
                                                <img src={item?.image?.file} alt={item?.name} />
                                            </button>
                                            <h6 className="text-primaryText dark:text-white font-semibold text-center">{item?.name}</h6>
                                        </div>
                                    ))}
                                </div>}
                                {((!!!search) && category?.length === 0) &&
                                    <div className="mb-[-50px] xlx:mb-[-60px]">
                                        <EmptyList />
                                    </div>
                                }

                                {(!!search && category?.length === 0) &&
                                    <div className="mb-[-70px] xlx:mb-[-120px] mt-[-30px] xlx:mt-[-50px]">
                                        <NoSearch onClick={() => { setSearch("") }} />
                                    </div>
                                }
                            </>}
                    </>}
            </div>

            {/* stores */}
            <div className="flex flex-col gap-[20px]">
                <h3 className="text-primaryText dark:text-white font-semibold">{t("passenger.stores.title")}</h3>

                {loading ?
                    <div className="grid grid-cols-1 xsm:grid-cols-2 md:grid-cols-3 msm:grid-cols-4 gap-[20px] w-full">
                        {Array.isArray(storeLoaderData) && storeLoaderData?.map((item: any, index: number) => (
                            <div className="w-full animate-pulse" key={index}>
                                <div className="rounded-[20px] h-[220px] xlx:h-[250px] w-full bg-gray-200 dark:bg-gray-700"></div>

                                <div className='flex flex-col gap-[4px] py-[15px]'>
                                    <div className="w-[40%] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                    <div className="w-[80%] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                    <div className="w-[60%] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                </div>
                            </div>
                        ))}
                    </div> :
                    <>
                        {isError ?
                            <div className="h-full w-full my-[-30px] xlx:my-[-60px]">
                                <Error />
                            </div>
                            :
                            <>
                                {data?.length > 0 && <div className="grid grid-cols-1 xsm:grid-cols-2 md:grid-cols-3 msm:grid-cols-4 gap-[20px] w-full">
                                    {Array.isArray(data) && data?.slice(0, 4)?.map((item: any, index: number) => (
                                        <div className="w-full" key={index}>
                                            <button className="img-zoom overflow-hidden rounded-[20px] w-full relative" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/store-products/${item?.store_code}`) : navigate(`/store-products/${item?.store_code}`)}>
                                                <img src={item?.image?.file} alt={item?.store_name} className="rounded-[20px] h-[220px] xlx:h-[250px] w-full" />

                                                <div className="absolute top-0 left-0 bottom-0 right-0 p-[16px] flex items-start justify-start">
                                                    <div className={`border border-[#C8C8C8] dark:border-[#454545] bg-opacity-[0.8] flex items-center justify-center px-[11px] h-[22px] rounded-[10px] text-white text-xs font-bold uppercase whitespace-nowrap ${item?.status === "open" ? "bg-[#10B85D]" : "bg-[#B81013]"}`}> {item?.status !== "open" ? `${lang === "en" ? "Closed" : lang === "hi" ? "बंद" : "बंद"}` : `${lang === "en" ? "Open" : lang === "hi" ? "खुला" : "उघडा"}`}</div>
                                                </div>
                                            </button>

                                            <div className='flex flex-col gap-[4px] pt-[10px] pb-[15px]'>
                                                <h4 className='text-primaryText dark:text-white font-semibold'>{item?.store_name}</h4>
                                                <h6 className='text-blackDark dark:text-textBlackDark font-medium'>{item?.description}</h6>
                                                <div className='flex gap-[8px]'>
                                                    <StSvg />
                                                    <h6 className='text-blackDull dark:text-textBlackDull font-medium'>{item?.station?.name}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>}
                                {((!!!search) && data?.length === 0) &&
                                    <div className="mb-[-50px] xlx:mb-[-60px]">
                                        <EmptyList />
                                    </div>
                                }

                                {(!!search && data?.length === 0) &&
                                    <div className="mb-[-70px] xlx:mb-[-120px] mt-[-30px] xlx:mt-[-50px]">
                                        <NoSearch onClick={() => { setSearch("") }} />
                                    </div>
                                }
                            </>}
                    </>}
            </div>
        </div >
    );
};

export default AllStores;